import { Route } from 'react-router';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import Assets from './Assets';
import CreateAsset from './CreateAsset';
import EditAsset from './EditAsset';
import ViewAsset from './ViewAsset';
import BookingOverview from '../bookingOverview/BookingOverview';
import AssetMenu from './AssetMenu';

/**
 * Asset feature routes
 * Base path: assets/
 */
export const assetRoutes = (
    <Route element={<SubNavigationLayout subNavigation={<ErrorBoundary key="/submenu/assets"><AssetMenu /></ErrorBoundary>} />}>
        <Route index element={<ErrorBoundary key="assets"><Assets /></ErrorBoundary>} />
        <Route path="create" element={<ErrorBoundary key="assets/create"><CreateAsset /></ErrorBoundary>} />
        <Route path=":id">
            <Route index element={<ErrorBoundary key="assets/:id"><ViewAsset /></ErrorBoundary>} />
            <Route path="edit" element={<ErrorBoundary key="assets/:id/edit"><EditAsset /></ErrorBoundary>} />
            <Route path="overview" element={<ErrorBoundary key="assets/:id/overview"><BookingOverview /></ErrorBoundary>} />
        </Route>
    </Route>
);
